module.exports = __webpack_public_path__ + "static/media/logo.e545ccf7.png";